export const CUSTOM_DATE_RANGE_ID = "custom";
export const CUSTOM_BY_DATE_ID = "byDate";
export const DEFAULT_RANGE = "ThisFiscalYear";